import { render, staticRenderFns } from "./DefaultView.vue?vue&type=template&id=00fd98b4&"
import script from "./DefaultView.vue?vue&type=script&lang=js&"
export * from "./DefaultView.vue?vue&type=script&lang=js&"
import style0 from "./DefaultView.vue?vue&type=style&index=0&id=00fd98b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_pcivgqzi2ggw3w32ihxlyfliwi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports